import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {useToast} from "../context/toast";
import axiosManager from "../services/axiosManager";

export const useLeadRequest = (applicationId) => {
    const {t} = useTranslation();
    const toast = useToast();

    const {
        mutateAsync: putLeadRequest, isPending: isPendingLeadRequest,
    } = useMutation({
        mutationFn: (bodyData) => axiosManager.put$(`applications/${applicationId}/parents`, bodyData).then((response) => response?.data),
        onError: () => {
            toast.error(t("errors.common"));
        },
    });

    return {
        putLeadRequest,
        isPendingLeadRequest,
    };
};
